import { ClassType, EntityType } from '@frontend/common';
import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { ConfirmationModal } from '@frontend/components/modal';
import { CommonMessage } from '@frontend/lang';
import { IProduct, ProductExtended } from '@frontend/product/types';

import { PlatformObjectBadge } from '../../../../modal/platform-object-badge/platform-object-badge.component';
import { useKitItemsDetail } from './kit-items-detail.controller';

export interface KitItemsDetailProps {
    product: ProductExtended;
}

export const KitItemsDetail = (props: KitItemsDetailProps) => {
    const viewProps = useKitItemsDetail(props);

    return (
        <div className='flex flex-col gap-4'>
            <ReactiveObjectList<IProduct>
                key={`kit-items-detail-list-${viewProps.listRefreshKey}`}
                label={CommonMessage.OBJECTS.PRODUCT.PLURAL}
                fetch={(arg) => viewProps.fetchKitItems(arg)}
                dispatch={viewProps.dispatch}
                columns={{
                    columns: ['id', 'quantity'],
                    headerOverwrite: new Map([
                        ['id', CommonMessage.OBJECTS.PRODUCT.DEFAULT],
                        ['quantity', CommonMessage.OBJECTS.COMMON_FIELDS.QUANTITY]
                    ]),
                    customCells: new Map([
                        [
                            'id',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <PlatformObjectBadge
                                        entityType={EntityType.PRODUCT}
                                        id={obj.row.original.id}
                                    />
                                </td>
                            )
                        ],
                        ['quantity', (obj) => <td className={defaultCellClassName}>{viewProps.getQuantity(obj.row.original.id)}</td>]
                    ])
                }}
                type={EntityType.PRODUCT}
                id='kit-items-detail-list'
                customHeaderComponent={
                    <div className='flex gap-2 pe-4 pt-4'>
                        {viewProps.selectedObjects.length > 0 && (
                            <DefaultSecondaryButton
                                key='kit-items-detail-unlink-button'
                                text={CommonMessage.BUTTONS.UNLINK}
                                onClick={() =>
                                    viewProps.openModal(viewProps.unlinkModalId, () => (
                                        <ConfirmationModal
                                            handleClose={() => viewProps.closeModal(viewProps.unlinkModalId)}
                                            show={true}
                                            message={CommonMessage.BUTTONS.FORMATTED_UNLINK(
                                                viewProps.selectedObjects.length,
                                                CommonMessage.OBJECTS.PRODUCT.DEFAULT,
                                                CommonMessage.OBJECTS.PRODUCT.PLURAL
                                            )}
                                            onConfirm={viewProps.unlinkSelectedProducts}
                                            severity={ClassType.DANGER}
                                        />
                                    ))
                                }
                                size='sm'
                            />
                        )}
                        <DefaultPrimaryButton
                            key='kit-items-detail-link-button'
                            text={CommonMessage.BUTTONS.LINK}
                            onClick={viewProps.openLinkModal}
                            size='sm'
                        />
                    </div>
                }
                multiSelectOptions={{}}
                selectedObjects={viewProps.setSelectedObjects}
                tableProps={{ hideFooter: true, defaultHeight: true }}
            />
        </div>
    );
};
